// React
import React from 'react';
// External
import { Container, Form } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
// Internal
import NavbarPrimary from 'components/shared/organisms/NavbarPrimary/NavbarPrimary';
import NavbarSecondary from 'components/shared/organisms/NavbarSecondary/NavbarSecondary';
import PageTitle from 'components/shared/atoms/PageTitle/PageTitle';
import ContentCard from 'components/shared/organisms/ContentCard/ContentCard';
import FooterBtnActions from 'components/shared/molecules/FooterBtnActions/FooterBtnActions';
import VetService from 'services/vet';
import {
    updateBooking,
    clearBooking
} from 'stores/actions';
import BrandService from 'services/brand';
import formatPhoneNumber from 'utils/formatPhoneNumber';
// Styles
import './styles.scss';
// Constants
import BOOKING_OPTIONS from 'constants/bookingOptions';
import isEmpty from 'lodash/isEmpty';
import ReactHtmlParser from 'react-html-parser';

const VET_SUPPLY_ORDER = 'vet supply order';

class NewBooking extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            bookingOptionSelected: null,
            bookingOptions: [],
            serviceTypeList: [],
            vetStaff: '',
            vetStaffError: false,
            vetServiceTypeError: false,
            vetRelationshipType: null,
            phoneNumber: '',
            vetBrandParent: null,
            defaultCollectionOption: null,
            officeLocation: {}
        };
        this.radioBtnGroup = React.createRef();
        this.getVetDetails();
        this.props.clearBooking();
        this.getBrandContact();
    }

    componentDidMount() {
        // Remove the product filter from local storage after mounting
        localStorage.removeItem('product-filter');
        localStorage.removeItem('is-pet-next');

        // Remove the product search from local storage before unmounting
        localStorage.removeItem('product-search');
        localStorage.removeItem('vet-supply-id')
        // Remove service type name
        localStorage.removeItem('service-type-name')
        // Remove session of booking
        localStorage.removeItem('createBookingFlag')
        // Remove collection address lat/lng
        localStorage.removeItem('collectionAddressLat')
        localStorage.removeItem('collectionAddressLng')
    }

    getDefaultBookingOption(bookingOptionList) {
        const params = new URLSearchParams(window.location.search);
        const defaultBookingOption = params.get("bookingoption");

        return defaultBookingOption
    }

    /**
     * @param {Object} evt - the event triggered by the radio btn
     */
    handleRadioBtn(evt) {
        // Stores the selected value
        // changing from direct dom manipulation to react api inorder to when render happens it will render the radio button also
        this.setState((prevState) => ({ 
            bookingOptionSelected: prevState.bookingOptions[evt.target.value], 
            vetServiceTypeError: false,
            bookingOptions: prevState.bookingOptions.map((option, index) => {
                option.isChecked = index == evt.target.defaultValue
                return option
            })
        }));
    }

    onClickPrev() {
        this.props.history.push('/dashboard');
    }

    /**
     * @todo handle the information of the staff member
     */
    onClickNext() {
        if (this.state.bookingOptionSelected) {
            localStorage.setItem('service-type-name',this.state.bookingOptionSelected.sugarAPIName.toLowerCase())
            if (!this.state.vetStaff) {
                this.setState({ vetStaffError: true });
                return;
            }

            const serviceType = this.state.serviceTypeList.find(
                (item) => item.name.toLowerCase() === this.state.bookingOptionSelected.sugarAPIName.toLowerCase()
            );
            if (serviceType) {
                this.props.updateBooking({
                    id: '',
                    quotedProducts: [],
                    vetStaff: this.state.vetStaff,
                    serviceType: serviceType.id,
                    bookingOptionSelected: this.state.bookingOptionSelected,
                    rawServiceType: serviceType,
                    defaultCollectionOption: this.state.defaultCollectionOption,
                    officeLocation: this.state?.officeLocation,
                    collectionDetails: null
                });

                this.props.history.push(this.state.bookingOptionSelected.path);
            }
        }

        if (!this.state.vetStaff) {
            this.setState({ vetStaffError: true });
        }

        if (!this.state.bookingOptionSelected) {
            this.setState({ vetServiceTypeError: true });
        }
    }


    /**
     * Gets the contact info of the brand
     */
    getBrandContact() {
        BrandService.getBrand()
            .then((response) => {
                this.setState({ phoneNumber: formatPhoneNumber(response.data.phone_work) });
            }).catch((err) => {
                console.error(err);
            });
    }

    /**
     * Retrieves the vet details to select the vet type for the services available
     */
    getVetDetails = () => {
        VetService.getVetDetails()
            .then((response) => {
                // Add code to assign the service types
                let brandParent = (response.data.cstm.brand.parent) ? response.data.cstm.brand.parent.replace(' Pet Cremation', '') : null;
                let collectionAddressOption;
                // Determine collectionAddressOption based on response data
                if (response.data.cstm.default_collection_location_c === 'Vet') {
                    collectionAddressOption = 'vet_address';
                } else if (response.data.cstm.default_collection_location_c === 'Customer') {
                    collectionAddressOption = 'customer_address';
                } else {
                    collectionAddressOption = 'postal_address';
                } 
                localStorage.setItem('createBookingFlag', response.data.opp_temporary_id);
                this.setState({ vetRelationshipType: response.data.cstm.relationship_type_c, vetBrandParent: brandParent, defaultCollectionOption: collectionAddressOption, officeLocation: response.data?.office_location });
                this.getServiceTypes();
            }).catch((err) => {
                console.error(err);
            });
    }

    /**
     * Retrieves the service types to display in the booking type selection
     */
    getServiceTypes = () => {
        VetService.getServiceTypes()
            .then((response) => {
                const responseData = response.data;
                let responseDataArr = [];
                if (!Array.isArray(responseData)) {
                    const keys = Object.keys(responseData);
                    keys.forEach((key) => {
                        responseDataArr.push(responseData[key]);
                    });
                } else {
                    responseDataArr = responseData;
                }

                let bookingOptionList = [];
                const defaultBookingOption = this.getDefaultBookingOption()

                responseDataArr.forEach((service) => {
                    let bookingOptions = BOOKING_OPTIONS.filter((option) => {

                        if (
                            option.sugarAPIName === service.name &&
                            ((option.vetRelationshipType && option.vetRelationshipType.toLowerCase() === this.state.vetRelationshipType.toLowerCase()) ||
                            !option.vetRelationshipType)
                        ) {
                            if (option.vetRelationshipType && ['referral', 'vet_unity'].includes(option.vetRelationshipType.toLowerCase())) {
                                option.feedback = option.feedback.replace('{brand}', this.state.vetBrandParent);
                            }

                            if(this.state.vetRelationshipType === 'vet_unity' && option.label.toLocaleLowerCase() === 'products only order') {
                                option.feedback = option.feedback.replace(/[()]/g, '')
                            }

                            if (this.state.vetRelationshipType === 'vet_unity' && option.label === 'Communal Cremation - Vet: Keepsakes') {
                                return false;
                            }
                            
                            option.isChecked = option?.sugarAPIName?.toLocaleLowerCase() === defaultBookingOption?.toLocaleLowerCase()
                            return option;
                        }
                    })

                    if (!isEmpty(bookingOptions)) {
                        bookingOptionList = [...bookingOptionList, ...bookingOptions];
                    }
                });

                this.setState({
                    bookingOptions: bookingOptionList,
                    serviceTypeList: responseDataArr,
                    bookingOptionSelected: bookingOptionList?.filter(i => i.isChecked)?.[0]
                });
            }).catch((err) => {
                console.error(err);
            });
    }

    render() {
        return (
            <div className="main-container">
                <NavbarSecondary />
                <NavbarPrimary />
                <div className="body-content">
                    <PageTitle title="New booking/order" />
                    <ContentCard
                        className="mt-62"
                        headerTitle="Select a booking/order option"
                        headerStyle={{ paddingBottom: '10px' }}
                        headerSubComponent={(
                            <p className="nb-header-text">
                                {`Start a new booking / order by selecting from the options below.
                                For horse or livestock bookings, please contact us.`}
                            </p>
                        )}
                    >
                        <Container className="nb-container">
                            <Form>
                                <Form.Group controlId="vetStaff" className="control-group">
                                    <Form.Label className={this.state.vetStaffError ? 'is-invalid' : ''}>Booking vet staff member name <span className="is-invalid">*</span></Form.Label>
                                    <Form.Control
                                        className={this.state.vetStaffError ? 'is-invalid' : ''}
                                        name="vetStaff"
                                        onChange={(evt) => this.setState({
                                            vetStaff: evt.target.value,
                                            vetStaffError: false
                                        })}
                                        type="text"
                                        autoFocus
                                        placeholder="Enter staff member name"
                                    />
                                </Form.Group>
                                <br />
                                <Form.Label className={this.state.vetServiceTypeError ? 'is-invalid' : ''}>Booking options <span className="is-required is-invalid">*</span></Form.Label>
                                <Form.Group ref={this.radioBtnGroup}>
                                    {this.state.bookingOptions.map((option, index) => (
                                        <Form.Check type="radio" id={`radio-${index}`} key={option.path}>
                                            <Form.Check.Input
                                                type="radio"
                                                value={index}
                                                onChange={(evt) => this.handleRadioBtn(evt)}
                                                checked={option.isChecked}
                                            />
                                            <Form.Check.Label>{option.label}</Form.Check.Label>
                                            <div className="label-help">{ReactHtmlParser(option.feedback)}</div>
                                        </Form.Check>
                                    )
                                    )}
                                </Form.Group>
                            </Form>
                        </Container>
                    </ContentCard>
                </div>
                <FooterBtnActions
                    prevBtnOnCLick={() => this.onClickPrev()}
                    nextBtnOnCLick={() => this.onClickNext()}
                />
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateBooking: (bookingObj) => dispatch(updateBooking(bookingObj)),
        clearBooking: () => dispatch(clearBooking())
    };
};

export default connect(null, mapDispatchToProps)(withRouter(NewBooking));